import { render, staticRenderFns } from "./PE_gameListComponent.vue?vue&type=template&id=c64f1682"
import script from "./PE_gameListComponent.vue?vue&type=script&lang=js"
export * from "./PE_gameListComponent.vue?vue&type=script&lang=js"
import style0 from "./PE_gameListComponent.vue?vue&type=style&index=0&id=c64f1682&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports